export enum AddressPathsEnum {
  ADDRESS_ADD = "/address-add",
  ADDRESS_LIST = "/my-addresses",
}
